import { useTranslation } from 'react-i18next';

import { classNames, noop } from '../../utils';
import { FileInput } from 'flowbite-react';

export const FileInputElement = ({
    name,
    value,
    label,
    accept = 'image/png, image/jpeg, .pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    forceWidth,
    onChange = noop
}: {
    name: string;
    value?: any;
    label?: string;
    accept?: string;
    forceWidth?: number;
    onChange?: (item: { [key: string]: string | number }) => void;
}) => {
    const { t } = useTranslation();

    const handleChange = (e: { target: { files: any } }) => {
        onChange({ [name]: e.target.files });
    };

    return (
        <div
            className={`'w-full  mb-[24px]'}`}
            style={{ width: forceWidth ? `${forceWidth}ch` : '100%' }}
        >
            {label && (
                <label
                    htmlFor={`${name}`}
                    className="block text-sm font-normal leading-6 text-black"
                >
                    {t(label)}
                </label>
            )}
            <div
                className={classNames(
                    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent outline-0',
                    'mt-1 relative border border-gray-dark shadow-sm'
                )}
            >
                <FileInput
                    value={value}
                    onChange={handleChange}
                    accept={accept}
                    multiple
                />
            </div>
        </div>
    );
};

